export default "__VITE_ASSET__0944ae21__"